<template>
  <div
    itemscope
    itemtype="https://schema.org/ContactPoint"
    id="usp-bar"
    class="bg-chalkboard text-center d-flex"
  >
    <VContainer class="c-ash-gray font-size-s pa-0 d-flex justify-center" fluid>
      <VFadeTransition>
        <div
          v-show="entity === 'phone'"
          class="usp justify-center align-center mx-3 flex-grow-1 d-lg-flex"
        >
          <SvgWrapper
            use="icon_svg_phone"
            dimensions="25"
            class="flex-shrink-0"
            :style="{
              fill: `rgb(var(--v-theme-white))`
            }"
          />
          <span class="ml-3" itemprop="telephone">
            {{ phoneNumber }}
          </span>
        </div>
      </VFadeTransition>
      <VFadeTransition>
        <div
          v-show="entity === 'delivery'"
          class="usp justify-center align-center mx-3 flex-grow-1 d-lg-flex"
        >
          <SvgWrapper
            use="icon_svg_delivery_free"
            dimensions="30"
            class="flex-shrink-0"
            :style="{
              fill: `rgb(var(--v-theme-white))`
            }"
          />
          <div>
            <div class="ml-3">
              {{ translate('free_shipping') }}
              {{ translate('shipping_subline') }}
            </div>
          </div>
        </div>
      </VFadeTransition>
      <VFadeTransition>
        <div
          v-show="entity === 'cashback'"
          class="usp align-center justify-center mx-3 flex-grow-1 d-lg-flex"
        >
          <SvgWrapper
            :use="
              this.locale === 'ch'
                ? 'icon_svg_money_return_chf'
                : 'icon_svg_money_return'
            "
            dimensions="25"
            class="flex-shrink-0"
            :style="{
              fill: `rgb(var(--v-theme-white))`
            }"
          />
          <div>
            <div class="font-weight-bold ml-3">
              {{ translate('cash_back_warranty') }}
            </div>
          </div>
        </div>
      </VFadeTransition>
    </VContainer>
  </div>
</template>

<script>
import SvgWrapper from '@/components/basic/atoms/SvgWrapper.vue'

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const {
      default: {
        phone: { text: phoneNumber },
        locale
      }
    } = await import('@/services/SiteConfig')

    cache = { phoneNumber, locale }
    return cache
  }
})()

const INTERVAL_DURATION = 3000
const FADE_DURATION = 350

export default {
  components: { SvgWrapper },
  data() {
    return {
      phoneNumber: '',
      locale: '',
      entity: 'phone',
      entities: ['phone', 'delivery', 'cashback'],
      lastIndex: 0
    }
  },

  async created() {
    const { phoneNumber, locale } = await _getModules()
    this.locale = locale
    this.phoneNumber = phoneNumber
    setInterval(() => {
      if (this.$vuetify.display.lgAndUp) return
      this.entity = 'none'
      setTimeout(() => {
        this.lastIndex = (this.lastIndex + 1) % this.entities.length
        this.entity = this.entities[this.lastIndex]
      }, FADE_DURATION)
    }, INTERVAL_DURATION)
  }
}
</script>

<style scoped>
#usp-bar {
  min-height: 30px;
}
.usp {
  display: flex;
  min-height: 30px;
}
</style>
